import { render, staticRenderFns } from "./addFrequency.vue?vue&type=template&id=995687c8&scoped=true&"
import script from "./addFrequency.vue?vue&type=script&lang=js&"
export * from "./addFrequency.vue?vue&type=script&lang=js&"
import style0 from "./addFrequency.vue?vue&type=style&index=0&id=995687c8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "995687c8",
  null
  
)

export default component.exports